module.exports = __webpack_public_path__ + "static/media/bizbook-about.a0431d94.png";